// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"GC-z","expressButtonContainerWithPayPal":"HC-z","expressButton":"IC-z","or":"JC-z"};